var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
    [
      _c("div", { staticClass: "row" }, [
        _vm.classHeadeDtls.data && _vm.classHeadeDtls.data.length > 0
          ? _c(
              "div",
              {
                staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 heading",
              },
              [
                _vm._v(
                  "Classification History (" +
                    _vm._s(_vm.classHeadeDtls.data.length) +
                    ") "
                ),
              ]
            )
          : _c(
              "div",
              {
                staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 heading",
              },
              [_vm._v("No Classification History found.")]
            ),
      ]),
      _c("div", { staticClass: "row hr-thin" }),
      _c(
        "base-collapse",
        _vm._l(_vm.classHeadeDtls.data, function (classData, indexClsRD) {
          return _c(
            "div",
            { key: indexClsRD, staticClass: "mb-12px" },
            [
              _c(
                "base-collapse-item",
                {
                  staticClass: "class-summary notification_box hist-hdr",
                  attrs: {
                    title:
                      classData.class_code +
                      "," +
                      classData.market +
                      "," +
                      classData.product_name,
                    name: indexClsRD + "Rule-DT",
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "service",
                      attrs: { href: "javascript:void(0);" },
                      on: {
                        click: function ($event) {
                          return _vm.routeProductClassificationRationale(
                            classData
                          )
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "row class_question" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7",
                          },
                          [_vm._v("Classification Question")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5",
                          },
                          [_vm._v("Response")]
                        ),
                      ]),
                      _vm._l(classData.details, function (dtlData, indexClsDD) {
                        return _c(
                          "div",
                          {
                            key: indexClsDD,
                            staticClass: "row class_question_summary p-t10-b10",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-7 col-md-7 col-sm-7 col-xs-7",
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(dtlData.question),
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-5 col-md-5 col-sm-5 col-xs-5",
                              },
                              [_vm._v(_vm._s(dtlData.response) + " ")]
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          )
        }),
        0
      ),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }